import React, { createContext, useEffect, useState } from 'react';
import Pusher from 'pusher-js';

export const PusherContext = createContext();

export const PusherProvider = ({ children }) => {
  const [pusher, setPusher] = useState(null);

  useEffect(() => {
    const key = process.env.REACT_APP_PUSHER_KEY;
    const cluster = process.env.REACT_APP_PUSHER_CLUSTER;
    
    if (!key || !cluster) {
      console.warn('[PusherProvider] Missing REACT_APP_PUSHER_KEY or REACT_APP_PUSHER_CLUSTER env vars');
      return;
    }
    
    const pusherInstance = new Pusher(key, { 
      cluster,
      enabledTransports: ['ws', 'wss']
    });
    
    // Only log errors
    pusherInstance.connection.bind('error', (err) => {
      console.error('[PusherProvider] Pusher error:', err);
    });
    
    setPusher(pusherInstance);
    
    return () => {
      pusherInstance.disconnect();
    };
  }, []);

  return (
    <PusherContext.Provider value={pusher}>
      {children}
    </PusherContext.Provider>
  );
};